import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "video-player-info-panel" }
const _hoisted_2 = { class: "video-player-info-panel__row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "video-player-info-panel__label" }, " ", -1)
const _hoisted_4 = { class: "video-player-info-panel__value" }
const _hoisted_5 = { class: "video-player-info-panel__row" }
const _hoisted_6 = { class: "video-player-info-panel__label" }
const _hoisted_7 = { class: "video-player-info-panel__value" }
const _hoisted_8 = { class: "video-player-info-panel__row" }
const _hoisted_9 = { class: "video-player-info-panel__label" }
const _hoisted_10 = { class: "video-player-info-panel__value" }
const _hoisted_11 = { class: "video-player-info-panel__row" }
const _hoisted_12 = { class: "video-player-info-panel__label" }
const _hoisted_13 = { class: "video-player-info-panel__value" }
const _hoisted_14 = { class: "video-player-info-panel__row" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "video-player-info-panel__label" }, "FPS", -1)
const _hoisted_16 = { class: "video-player-info-panel__value" }
const _hoisted_17 = { class: "video-player-info-panel__row" }
const _hoisted_18 = { class: "video-player-info-panel__label" }
const _hoisted_19 = { class: "video-player-info-panel__value" }
const _hoisted_20 = { class: "video-player-info-panel__row" }
const _hoisted_21 = { class: "video-player-info-panel__label" }
const _hoisted_22 = { class: "video-player-info-panel__value" }
const _hoisted_23 = { class: "video-player-info-panel__row" }
const _hoisted_24 = { class: "video-player-info-panel__label" }
const _hoisted_25 = { class: "video-player-info-panel__value" }
const _hoisted_26 = { class: "video-player-info-panel__row" }
const _hoisted_27 = { class: "video-player-info-panel__label" }
const _hoisted_28 = { class: "video-player-info-panel__value" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "video-player-info-panel__row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "video-player-info-panel__label" }, " "),
  /*#__PURE__*/_createElementVNode("div", { class: "video-player-info-panel__value" }, " ")
], -1)
const _hoisted_30 = { class: "video-player-info-panel__row" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "video-player-info-panel__label" }, null, -1)
const _hoisted_32 = { class: "video-player-info-panel__value n-flex" }
const _hoisted_33 = {
  key: 0,
  class: "video-player-info-panel__col"
}
const _hoisted_34 = {
  key: 1,
  class: "video-player-info-panel__col"
}
const _hoisted_35 = {
  key: 2,
  class: "video-player-info-panel__col"
}
const _hoisted_36 = { class: "video-player-info-panel__row" }
const _hoisted_37 = { class: "video-player-info-panel__label" }
const _hoisted_38 = { class: "video-player-info-panel__value n-flex" }
const _hoisted_39 = {
  key: 0,
  class: "video-player-info-panel__col"
}
const _hoisted_40 = {
  key: 1,
  class: "video-player-info-panel__col"
}
const _hoisted_41 = {
  key: 2,
  class: "video-player-info-panel__col"
}
const _hoisted_42 = { class: "video-player-info-panel__row" }
const _hoisted_43 = { class: "video-player-info-panel__label" }
const _hoisted_44 = { class: "video-player-info-panel__value n-flex" }
const _hoisted_45 = {
  key: 0,
  class: "video-player-info-panel__col"
}
const _hoisted_46 = {
  key: 1,
  class: "video-player-info-panel__col"
}
const _hoisted_47 = {
  key: 2,
  class: "video-player-info-panel__col"
}
const _hoisted_48 = { class: "video-player-info-panel__row" }
const _hoisted_49 = { class: "video-player-info-panel__label" }
const _hoisted_50 = { class: "video-player-info-panel__value n-flex" }
const _hoisted_51 = {
  key: 0,
  class: "video-player-info-panel__col"
}
const _hoisted_52 = {
  key: 1,
  class: "video-player-info-panel__col"
}
const _hoisted_53 = {
  key: 2,
  class: "video-player-info-panel__col"
}
const _hoisted_54 = { class: "video-player-info-panel__close-icon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NIcon = _resolveComponent("NIcon")!
  const _directive_drag_helper = _resolveDirective("drag-helper")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.getCameraValue('health_status.status')), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('video_player.time_working')), 1),
      _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.formatTime(_ctx.getStatisticValue('last_stream_timestamp', 0))), 1)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('video_player.process_duration')), 1),
      _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.formatDuration(_ctx.getStatisticValue('processed_duration', 0))), 1)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('video_player.frames_imotion_skipped')), 1),
      _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.getStatisticValue('frames_imotion_skipped')), 1)
    ]),
    _createElementVNode("div", _hoisted_14, [
      _hoisted_15,
      _createElementVNode("div", _hoisted_16, _toDisplayString(Math.round(_ctx.getStatisticValue('processing_fps', 0))), 1)
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('video_player.resolution')), 1),
      _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.getStatisticValue('frame_width', 0)) + "x" + _toDisplayString(_ctx.getStatisticValue('frame_height', 0)), 1)
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t('video_player.job_starts')), 1),
      _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.getStatisticValue('job_starts')), 1)
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t('video_player.frames_dropped')), 1),
      _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.getStatisticValue('frames_dropped')), 1)
    ]),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t('video_player.frames_processed')), 1),
      _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.getStatisticValue('frames_processed')), 1)
    ]),
    _hoisted_29,
    _createElementVNode("div", _hoisted_30, [
      _hoisted_31,
      _createElementVNode("div", _hoisted_32, [
        (_ctx.faceAvailable)
          ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
              _createVNode(_component_NIcon, { name: "detect-face" })
            ]))
          : _createCommentVNode("", true),
        (_ctx.bodyAvailable)
          ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
              _createVNode(_component_NIcon, { name: "detect-body" })
            ]))
          : _createCommentVNode("", true),
        (_ctx.carAvailable)
          ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
              _createVNode(_component_NIcon, { name: "detect-auto" })
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_36, [
      _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.$t('video_player.decoding_errors')), 1),
      _createElementVNode("div", _hoisted_38, [
        (_ctx.faceAvailable)
          ? (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString(_ctx.getStatisticValue('objects.face.not_posted')), 1))
          : _createCommentVNode("", true),
        (_ctx.bodyAvailable)
          ? (_openBlock(), _createElementBlock("div", _hoisted_40, _toDisplayString(_ctx.getStatisticValue('objects.body.not_posted')), 1))
          : _createCommentVNode("", true),
        (_ctx.carAvailable)
          ? (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString(_ctx.getStatisticValue('objects.car.not_posted')), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_42, [
      _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.$t('video_player.objects_posted')), 1),
      _createElementVNode("div", _hoisted_44, [
        (_ctx.faceAvailable)
          ? (_openBlock(), _createElementBlock("div", _hoisted_45, _toDisplayString(_ctx.getStatisticValue('objects.face.posted')), 1))
          : _createCommentVNode("", true),
        (_ctx.bodyAvailable)
          ? (_openBlock(), _createElementBlock("div", _hoisted_46, _toDisplayString(_ctx.getStatisticValue('objects.body.posted')), 1))
          : _createCommentVNode("", true),
        (_ctx.carAvailable)
          ? (_openBlock(), _createElementBlock("div", _hoisted_47, _toDisplayString(_ctx.getStatisticValue('objects.car.posted')), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_48, [
      _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.$t('video_player.objects_failed')), 1),
      _createElementVNode("div", _hoisted_50, [
        (_ctx.faceAvailable)
          ? (_openBlock(), _createElementBlock("div", _hoisted_51, _toDisplayString(_ctx.getStatisticValue('objects.face.failed')), 1))
          : _createCommentVNode("", true),
        (_ctx.bodyAvailable)
          ? (_openBlock(), _createElementBlock("div", _hoisted_52, _toDisplayString(_ctx.getStatisticValue('objects.body.failed')), 1))
          : _createCommentVNode("", true),
        (_ctx.carAvailable)
          ? (_openBlock(), _createElementBlock("div", _hoisted_53, _toDisplayString(_ctx.getStatisticValue('objects.car.failed')), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_54, [
      _createVNode(_component_NIcon, {
        name: "vp-close-panel",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      })
    ])
  ])), [
    [_directive_drag_helper]
  ])
}